import * as React from 'react';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import logoIcon from 'assets/img/logo.png';
import { theme } from 'theme/MainTheme';

function Navbar() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const onLogoutClick = () => {
    setAnchorElNav(null);
    navigate('/admin_login');
  };

  const LogoWrapper = styled.div`
    width: 160px;
    height: 50px;
    background-image: url(${logoIcon});
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 80%;
  `;

  return (
    <AppBar position="static" sx={{ backgroundColor: theme.white }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <LogoWrapper sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/panel_adm"
            sx={{
              mr: 2,
              display: { xs: 'none', sm: 'flex' },
              fontFamily: 'Montserrat',
              fontWeight: 700,
              letterSpacing: '.3rem',
              textDecoration: 'none',
              color: theme.grey500,
            }}
          >
            PANEL ADMINISTRACYJNY
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'flex', md: 'flex', justifyContent: 'flex-end' },
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon sx={{ fill: theme.primary, fontSize: '3rem' }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              <MenuItem onClick={handleCloseNavMenu} sx={{ fontSize: '1.3rem' }}>
                <Link to="/admin_settings" style={{ textDecoration: 'none', color: theme.black }}>
                  Ustawienia
                </Link>
              </MenuItem>
              <MenuItem sx={{ fontSize: '1.3rem' }} onClick={handleCloseNavMenu}>
                <Link to="/admin_logs" style={{ textDecoration: 'none', color: theme.black }}>
                  Logi
                </Link>
              </MenuItem>
              <MenuItem sx={{ fontSize: '1.3rem' }} onClick={onLogoutClick}>
                Wyloguj
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
